import { Component } from 'react';
import WelcomeMessage from '../WelcomeMessage/WelcomeMessage';
import WebComponenetsRenderer from '../WebComponentsRenderer/WebComponenetsRenderer'
import { Configuration } from '../../types/Configuration';
import Sticky from 'react-stickynode';
import SideNavigation from '../SideNavigation/SideNavigation';
import './my-account-main.scss'

type Props = {
    selectedLanguage: string
    configuration: Configuration
    accessToken: string,
    tokenIsProvided: boolean,
    isMobile: boolean
}

class MyAccountMain extends Component<Props> {
    render() {
        const stickyTop = (
            document.getElementsByClassName('dw-main-menu')[0]?.clientHeight + 20
        );

        return (
            <div className='dw-container my-account'>
                <div className='dw-side-menu'>
                    {!this.props.isMobile ?
                        <Sticky top={stickyTop} bottomBoundary="#sticky-break">
                            <SideNavigation
                                selectedLanguage={this.props.selectedLanguage}
                                configuration={this.props.configuration}
                                isMobile={this.props.isMobile} />
                        </Sticky> :
                        <SideNavigation
                            selectedLanguage={this.props.selectedLanguage}
                            configuration={this.props.configuration}
                            isMobile={this.props.isMobile} />
                    }

                </div>
                <div className='dw-main-body'>
                    <WelcomeMessage
                        selectedLanguage={this.props.selectedLanguage}
                        docuwareBaseUrl={this.props.configuration.docuwareBaseUrl} />
                    <WebComponenetsRenderer
                        accessToken={this.props.accessToken}
                        selectedLanguage={this.props.selectedLanguage}
                        configuration={this.props.configuration}
                        tokenIsProvided={this.props.tokenIsProvided}
                    />
                </div>
            </div>
        )
    }
}

export default MyAccountMain;